import styled from "styled-components";

export const Wrapper = styled.div`
    background: var(--darkGrey);
    padding: 0 20px;
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: var(--maxWidth);
    margin: 0 auto;
`;

export const LogoImg = styled.img`
    height: 70px;

    @media (max-width: 500px) {
        height: 50px;
    }
`;

export const TMDBLogoImg = styled.img`
    height: 50px;

    @media (max-width: 500px) {
        height: 40px;
    }
`;
